class Drawer {
    constructor(title, content, options = {}) {
        this.title = title;
        this.content = content;
        this.options = Object.assign({
            side: 'right',           // 'left' or 'right'
            width: 'w-auto',      // Tailwind width class
            closeOnBackdrop: true,
        }, options);
        this.drawer = null;
        this.backdrop = null;
        this.buttons = [];
        this.events = [];
    }

    setButtons(buttons) {
        this.buttons = buttons;
        return this;
    }

    setEvents(events) {
        this.events = events;
        return this;
    }

    show() {
        this.backdrop = document.createElement('div');
        this.backdrop.className =
            'fixed inset-0 bg-black/30 z-40 opacity-0 transition-opacity duration-300';
        document.body.appendChild(this.backdrop);

        const side = this.options.side === 'left' ? 'left-0' : 'right-0';
        this.drawer = document.createElement('div');
        this.drawer.className = `
            fixed top-0 ${side} h-full ${this.options.width}
            bg-white shadow-2xl z-50 transform transition-transform duration-300
            ${this.options.side === 'left' ? '-translate-x-full' : 'translate-x-full'}
            flex flex-col
        `;

        const header = document.createElement('div');
        header.className =
            'px-5 py-4 border-b flex justify-between items-center bg-gray-50';
        header.innerHTML = `
            <h3 class="text-lg font-semibold text-gray-800">${this.title}</h3>
            <button class="text-gray-500 hover:text-gray-700 text-2xl leading-none">&times;</button>
        `;

        const body = document.createElement('div');
        body.className = 'flex-grow overflow-y-auto p-5';
        body.innerHTML = this.content;

        const footer = document.createElement('div');
        footer.className =
            'px-5 py-4 border-t bg-gray-50 flex justify-end space-x-3';

        if (this.buttons.length > 0) {
            this.buttons.forEach((btnConfig) => {
                const button = document.createElement('button');
                button.className = `px-4 py-2 rounded-lg font-medium ${btnConfig.class || 'bg-blue-500 text-white hover:bg-blue-600'}`;
                button.textContent = btnConfig.name;

                if (btnConfig.dismiss) {
                    button.addEventListener('click', () => this.hide());
                }
                if (btnConfig.onClick) {
                    button.addEventListener('click', (e) => {
                        btnConfig.onClick.call(button, {
                            data: { drawer: this.drawer },
                            event: e
                        });
                    });
                }

                footer.appendChild(button);
            });
        } else {
            const closeBtn = document.createElement('button');
            closeBtn.className =
                'px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 font-medium';
            closeBtn.textContent = 'Close';
            closeBtn.addEventListener('click', () => this.hide());
            footer.appendChild(closeBtn);
        }

        this.drawer.appendChild(header);
        this.drawer.appendChild(body);
        this.drawer.appendChild(footer);
        document.body.appendChild(this.drawer);

        header.querySelector('button').addEventListener('click', () => this.hide());

        if (this.options.closeOnBackdrop) {
            this.backdrop.addEventListener('click', (e) => {
                if (e.target === this.backdrop) this.hide();
            });
        }

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.backdrop.classList.add('opacity-100');
                this.drawer.classList.remove(
                    this.options.side === 'left' ? '-translate-x-full' : 'translate-x-full'
                );
            });
        });

        // Fire show events
        this.events
            .filter((e) => e.action === 'show')
            .forEach((event) => event.callback({ data: { drawer: this.drawer } }));

        return this;
    }

    hide() {
        if (!this.drawer) return;

        // Animate out
        this.drawer.classList.add(
            this.options.side === 'left' ? '-translate-x-full' : 'translate-x-full'
        );
        this.backdrop.classList.remove('opacity-100');

        // Fire hide events
        this.events
            .filter((e) => e.action === 'hide')
            .forEach((event) => event.callback({ data: { drawer: this.drawer } }));

        setTimeout(() => {
            this.drawer.remove();
            this.backdrop.remove();
            this.drawer = null;
            this.backdrop = null;
        }, 300);
    }
}
